import { kcAuth } from '@/clients/keycloak';
import { ROLE_LIST_NAME } from '@/clients/keycloak/type';
import { parseActivationToken } from '@/components/utils';
import { Icon, Button, Row, Col } from 'antd';
import React, { useEffect, useState } from 'react';

type ActivationField = {
  userId: string;
  username: string;
  role: string;
  purpose: string;
  target: string;
};

const ActivationCallback = () => {
  const [isInvalidToken, setInvalidToken] = useState(false);
  const [isSuccessActive, setSuccessActive] = useState(false);
  const [textActive, setTextActive] = useState('Activating.');
  const [dateNum, setDateNum] = useState(new Date().getTime());
  const [tempNum, setTempNum] = useState(new Date().getTime());
  const [userRole, setUserRole] = useState('Super Admin');

  const activateUser = async (tokenData: ActivationField) => {
    const userData = await kcAuth.getUserByIdActivation(tokenData.userId);
    if (
      userData &&
      userData.attributes &&
      userData.attributes.role &&
      userData.attributes.role.length > 0
    ) {
      const userRole = userData.attributes.role[0];
      if (
        tokenData.role === ROLE_LIST_NAME[userRole] &&
        tokenData.username === userData.username
      ) {
        await kcAuth.activateUser(tokenData.userId);
        setSuccessActive(true);
      } else setInvalidToken(true);
    } else setInvalidToken(true);
  };

  const gotoLoginPage = () => {
    window.location.replace('/login');
  };

  useEffect(() => {
    const tokenData = parseActivationToken();
    if (tokenData) {
      setUserRole(tokenData.role);
      activateUser(tokenData);
    } else setInvalidToken(true);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const newNum = new Date().getTime();
    const diff = newNum - dateNum;
    if (diff >= 200) {
      if (textActive.length === 11) {
        setTextActive('Activating..');
      } else if (textActive.length === 12) {
        setTextActive('Activating...');
      } else {
        setTextActive('Activating.');
      }
      setDateNum(newNum);
    }
    setTimeout(() => {
      const newNum = new Date().getTime();
      setTempNum(newNum);
    }, 400);
    // eslint-disable-next-line
  }, [tempNum]);

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        backgroundColor: '#F0F0F0',
        padding: '24px',
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: 'white',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '8px',
          boxShadow: '0px 3px 6px #00000029',
        }}
      >
        {isInvalidToken ? (
          <Row>
            <Col
              style={{
                fontSize: '120px',
                color: '#F62B2B',
                textAlign: 'center',
              }}
            >
              <Icon type="warning" theme="filled" />
            </Col>
            <Col
              style={{
                fontFamily: 'Samsung Sharp Sans Bold',
                fontSize: '42px',
                color: '#070707',
                textAlign: 'center',
              }}
            >
              {'ACTIVATION USER FAILED'}
            </Col>
            <Col
              style={{
                fontFamily: 'Samsung Sharp Sans Regular',
                fontSize: '28px',
                color: '#070707',
                textAlign: 'center',
              }}
            >
              {'Invalid Token.'}
            </Col>
            <Col
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '50px',
              }}
            >
              <Button
                style={{
                  fontFamily: 'Samsung Sharp Sans Bold',
                  fontSize: '29px',
                  width: '230px',
                  height: '65px',
                }}
                onClick={gotoLoginPage}
                type="primary"
              >
                OK
              </Button>
            </Col>
          </Row>
        ) : !isSuccessActive ? (
          <div style={{ width: '200px' }}>
            <Icon
              style={{ fontSize: '28px', marginRight: '10px' }}
              type="loading-3-quarters"
              spin
            />
            <span
              style={{
                fontFamily: 'Samsung Sharp Sans Bold',
                fontSize: '28px',
              }}
            >
              {textActive}
            </span>
          </div>
        ) : (
          <Row>
            <Col
              style={{
                fontSize: '140px',
                color: '#139C80',
                textAlign: 'center',
              }}
            >
              <Icon type="check-circle" />
            </Col>
            <Col
              style={{
                fontFamily: 'Samsung Sharp Sans Bold',
                fontSize: '42px',
                color: '#070707',
                textAlign: 'center',
                marginBottom: '30px',
              }}
            >
              {'ACTIVATION SUCCESSFUL'}
            </Col>
            <Col
              style={{
                fontFamily: 'Samsung Sharp Sans Regular',
                fontSize: '28px',
                color: '#070707',
                textAlign: 'center',
              }}
            >
              <div>
                {`Congratulations, your registration for ${userRole} has been
                successfully activated.`}
              </div>
              <div>You can continue to Login to Device Registration.</div>
            </Col>
            <Col
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '70px',
              }}
            >
              <Button
                style={{
                  fontFamily: 'Samsung Sharp Sans Bold',
                  fontSize: '29px',
                  width: '230px',
                  height: '65px',
                }}
                onClick={gotoLoginPage}
                type="primary"
              >
                OK
              </Button>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

export default ActivationCallback;
